import gql from 'graphql-tag'

export const GET_OWN_INTAKE_QUERY = gql`
query GetOwnIntakeQuery {
  getOwnIntake {
    id
    childFirstName
    childLastName
    childNickname
    childDateOfBirth
    childGender
    childHadGeneralAnesthesia
    childHandledGeneralAnesthesia
    childHandledLastMedicalEncounter
    checkedChildReactionsText
    childAfraidOfBurglars
    childAfraidOfLoudNoises
    childNotAfraidOfTheDark
    childAfraidOfFire
    childAfraidOfTheDark
    childRarelyAfraidMonsters
    checkedParentInfoText
    parentAge
    parentRole
    parentAnxiousness
    checkedParentDescribeText
    parentFeelPleasant
    parentTireQuickly
    parentFeelCrying
    parentWishCouldBeHappy
    parentLoosingOut
    parentFeelRested
    parentAmCalmCoolCollected
    parentDifficultiesNotOvercome
    parentWorryTooMuch
    parentAmHappy
    parentTakeThingsHard
    parentLackSelfConfidence
    parentFeelSecure
    parentAvoidCrisis
    parentFeelBlue
    parentAmContent
    parentUnimportantThoughtsBother
    parentTakeDisappointmentsTooKeenly
    parentTensionAndTurmoil
    parentSteadyPerson
    parentDentistAsk
    parentDentistTranquilizerOrDrink
    parentDentistThinkPleasant
    parentDentistTellMeAboutPain
    parentDentistTrySleep
    parentDentistWatchMovementsAndListenDrill
    parentDentistWatchForBlood
    parentDentistMentalPuzzles
    parentPlaneReadEmergency
    parentPlaneSmallTalk
    parentPlaneWatchMovie
    parentPlaneAskFlightAttendant
    parentPlaneTranquilizerOrDrink
    parentPlaneListenEnginesAndCrew
    parentPlaneTalkAboutIssue
    parentPlaneReadOrWrite
    parentShareFeelings
    parentRespectOthers
    parentMakeSacrifices
  parentHasProblems
  wouldHelpRelatives
  shouldLiveLong
  agingParents
  shouldShareWithRelatives
  helpRelatives
  helpEconomically
  shouldBeEmbarrassed
  shouldPleaseParents
  familyShouldConsult
  canCountOnRelative
  shouldLiveInParentsHouse
  goalToHaveChildren
    parentAvoidConflict
    parentControlEmotions
    parentShowLoyalty
    parentObeyWishes
    parentShowAgreement
    parentGoodManners
    parentFeelComfortable
    parentAvoidRudeness
    childFavoriteToys
    childFavoriteGames
    childEnjoysMovies
    childPets
    childSportsOrExtracurricular
    checkedPainMedsInfoText
    painMedsWorrySideEffects
    painMedsConcernedAddictionAbuse
    painMedsWorksBestRarelyWorst
    painMedsChildrenFeelLessPain
    painMedsExpressCryingWhining
    surgeryType
    surgeryOptionsBeWithChild
    surgeryOptionsReceiveSedative
    surgeryOptionsNeither
    characterChoice
    
    # religous
    religousQ1
    religousQ2
    religousQ3
    religousQ4
    religousQ5
    religousQ6
    religousQ7

    # review 1
    review1CheckedDescribeText
    review1PrepMorningSurgery
    review1DeepBreathingExcept
    review1GuidedImageryExcept
    review1InductionOfAnesthesia
    review1AnesthesiaMaskExcept

    # review 2
    review2CheckedDescribeText
    review2GuidelinesEatingAndDrinkingBeforeSurgery
    review2KeepChildCalm
    review2TrueAboutParentsExcept
    review2TrueAboutSedativeMedExcept
    review2ImportantOneParentInLobby

    # review 3
    review3CheckedDescribeText
    review3TrueAboutRecoveryRoomExcept
    review3ChildsPainManagedInRecoveryRoom
    review3DistractionGoodTechniqueRecoveryRoom
    review3AllWaysHelpChildInRecoveryRoomExcept
    review3SomeChildrenStillAsleepRecoveryRoom

    # review 4
    review4CheckedDescribeText
    review4OnceChildDischargedHowSoonEat
    review4AllSignsChildInPainExcept
    review4ReassuranceAtHome
    review4BestWayManageParentAnxiety
    review4AllTrueAboutManagingChildsPainAtHomeExcept
    
    furthestContentPage
    furthestWebinfoPage
    hasAcceptedDisclaimer
  }
  me {
    id
    username
    email
    userType
    site {
      id
      name
      pdfMapUri
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/queries/GET_OWN_INTAKE_QUERY.ts